import {EventEmitter, Injectable} from '@angular/core';
import {
  AddOnErrorEvent,
  AuthenticateEvent,
  CartChangeEvent,
} from './event.interface';
import {CommerceEventEmitter} from './commerce-event-emitter';

@Injectable({providedIn: 'root'})
export class CartCompanionEventEmitterService {
  authenticate?: EventEmitter<AuthenticateEvent>;
  cartLoad?: EventEmitter<CartChangeEvent>;
  cartUpdate?: EventEmitter<CartChangeEvent>;
  addOnError?: EventEmitter<AddOnErrorEvent>;

  bind(component: CommerceEventEmitter): void {
    this.cartLoad = component.cartLoad;
    this.cartUpdate = component.cartUpdate;
    this.addOnError = component.addOnError;
    this.authenticate = component.authenticate;
  }
}
